import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "two-factor-auth-modal-card" }
const _hoisted_2 = { class: "two-factor-auth-modal-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["CommonModal"], {
    "can-close": false,
    "is-full-screen": true,
    ref: "commonModal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createCommentVNode(" <NavigatorController\n        v-show=\"!user?.getHasTwoFactorKey()\"\n        :currentPage=\"currentPage\"\n        :totalPages=\"Object.keys(components).length\"\n      /> "),
        _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"height":"40px"} }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent($setup.components[$setup.currentPage]), {
            "admin-user": $setup.user,
            "current-page": $setup.currentPage,
            onChangePage: _cache[0] || (_cache[0] = (page) => {
            $setup.currentPage = page;
            if ($setup.currentPage > Object.values($setup.components).length) {
              $setup.submit();
            }
          }),
            secret: $setup.twoFactorAuthStore.secret,
            "qr-code-url": $setup.twoFactorAuthStore.qrCodeUrl,
            onOnInitialize: $setup.initialize,
            onOnSubmit: _cache[1] || (_cache[1] = () => {}),
            onOnCodeInputChange: _cache[2] || (_cache[2] = (value) => $setup.handleCodeInput(value))
          }, null, 40 /* PROPS, NEED_HYDRATION */, ["admin-user", "current-page", "secret", "qr-code-url"]))
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}